import React from 'react';

import useTimeElapsed from 'containers/EmployeeTimeClock/shared/useTimeElapsed';

interface IProps {
  pause: boolean;
}

const ClockInTimer: React.FC<IProps> = ({ pause }) => {
  const timer = useTimeElapsed(pause);

  return <>{timer}</>;
};
export default ClockInTimer;
